module.exports = {
          srcSet: __webpack_public_path__ + "3457bea0605d3c93a03894003021a061-382.png"+" 382w",
          images:[ {path: __webpack_public_path__ + "3457bea0605d3c93a03894003021a061-382.png",width: 382,height: 351}],
          src: __webpack_public_path__ + "3457bea0605d3c93a03894003021a061-382.png",
          toString:function(){return __webpack_public_path__ + "3457bea0605d3c93a03894003021a061-382.png"},
          
          width: 382,
          height: 351
        }